import Image from 'next/image';
import classnames from 'classnames';

import Heading from '@/components/renderers/Heading';
import MarkdownRenderer from '@/components/MarkdownRenderer';
import Button from '@/components/Button';

export default function ContentBlock(
  { image, title, content, cta, ctaTo },
  index,
) {
  const isEven = index % 2;

  const wrapperClass = classnames(
    '-mx-6 flex items-center flex-col lg:flex-row py-6 lg:py-12',
    {
      'lg:flex-row-reverse': isEven,
    },
  );

  return (
    <article key={index} className={wrapperClass}>
      <div className="w-full lg:w-1/2 px-6 flex items-center justify-center mb-6 lg:mb-0">
        {image && (
          <div className="m-auto relative z-20">
            <Image
              src={image.url}
              title={title}
              alt={title}
              width={image.width}
              height={image.height}
              quality={100}
              objectFit="cover"
              className="rounded w-full h-full"
            />
          </div>
        )}
      </div>

      <div className="w-full lg:w-1/2 px-6">
        <div className="-mt-6">
          {title && <Heading level={4}>{title}</Heading>}

          <MarkdownRenderer content={content} />

          {ctaTo && (
            <Button href={ctaTo} colour="purple">
              {cta || 'Learn more'} &#8594;
            </Button>
          )}
        </div>
      </div>
    </article>
  );
}
